"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SeparatorSymbol = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

/**
 * The Separator Symbol
 *
 * @param {width}         size  Logo width
 * @param {height}        size  Logo height
 * @param {background}    color Background color
 * @param {primary}       color Primary color
 * @param {secondary}     color Secondary color
 *
 **/
var SeparatorSymbol = function SeparatorSymbol(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 'auto' : _ref$height,
      _ref$background = _ref.background,
      background = _ref$background === void 0 ? '#002744' : _ref$background,
      _ref$primary = _ref.primary,
      primary = _ref$primary === void 0 ? '#0bbbef' : _ref$primary,
      _ref$secondary = _ref.secondary,
      secondary = _ref$secondary === void 0 ? '#ffed00' : _ref$secondary;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: width,
    height: height,
    viewBox: "0 0 87.254 87.431",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      transform: "translate(-1304.709 -527.551)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        fill: primary,
        width: "4.701",
        height: "10.433",
        rx: "2.35",
        transform: "translate(1370.715 595.154) rotate(-43)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        fill: primary,
        width: "4.701",
        height: "10.009",
        rx: "2.35",
        transform: "translate(1316.55 540.947) rotate(-43)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        fill: primary,
        width: "4.701",
        height: "9.162",
        rx: "2.35",
        transform: "translate(1329.726 534.328)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        fill: primary,
        width: "4.701",
        height: "8.95",
        rx: "2.35",
        transform: "translate(1363.372 596.865)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        fill: secondary,
        width: "4.701",
        height: "4.702",
        rx: "2.35",
        transform: "translate(1380.698 584.503) rotate(90)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
        fill: secondary,
        width: "4.701",
        height: "4.702",
        rx: "2.35",
        transform: "translate(1321.784 551.11) rotate(90)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        fill: background,
        d: "M639.135,281.6a5.37,5.37,0,0,1,1.683-4.129c1.609-1.642,8.488-8.488,8.488-8.488a15.027,15.027,0,0,1,2.793,2.793c.8,1.423,1.467,2.927,2.3,4.329.961,1.611,2.141,2.957,4.274,3.01,2.978.075,7.339-4.325,6.15-7.617-.607-1.681-1.979-2.563-3.4-3.386-1.145-.662-2.365-1.193-3.512-1.851a13.5,13.5,0,0,1-2.942-2.942c30.963-31.013,32.173-32.228,33.376-33.45a7.925,7.925,0,0,1,11.582-.107c2.233,2.185,4.338,4.508,6.648,6.605,3.036,2.755,2.568,6.445-1.609,8.165a15.214,15.214,0,0,0-3.355,1.627,2.975,2.975,0,0,0-.851,4.386,7.017,7.017,0,0,0,2.37,2.38,2.952,2.952,0,0,0,4.444-.925,25.171,25.171,0,0,0,1.58-3.252,13.593,13.593,0,0,1,.966-1.73,3.983,3.983,0,0,1,6.119-.817,101.343,101.343,0,0,1,8.41,8.47c2.628,3.07,2.205,7.6-.862,10.683-4.427,4.448-33.486,33.5-33.486,33.5a10.66,10.66,0,0,1-2.6-2.6c-.883-1.6-1.663-3.269-2.647-4.8-2.122-3.31-5.146-3.613-8.036-.9a7.613,7.613,0,0,0-1.743,2.183c-1.34,2.774-.495,5.087,2.444,6.7,1.365.749,2.759,1.447,4.121,2.2a13.1,13.1,0,0,1,2.842,2.842s-6.672,6.72-8.222,8.257c-2.694,2.671-5.991,2.669-8.689-.03-7.7-7.705-25.692-25.722-26.974-27.035A5.3,5.3,0,0,1,639.135,281.6ZM704.966,258a9.962,9.962,0,0,1-7.805-4.95c-2.6-4.045-1.624-8.19,2.411-10.809a21.074,21.074,0,0,1,3.372-1.6c.352-.148,1.192-.412,1.192-.412s-5.167-5.263-7.312-7.365a3.529,3.529,0,0,0-5.294.041c-.894.868-22.7,22.7-22.7,22.7l11.58,11.58a19.8,19.8,0,0,0,1.886-2.628c.579-1.188,1.063-2.423,1.667-3.6a5.225,5.225,0,0,1,7.174-2.6,8.819,8.819,0,0,1,3.759,3.412c1.944,3.187,1.055,6.316-2.294,8.027-1.072.548-2.191,1-3.268,1.54a13,13,0,0,0-2.612,2.155l11.38,11.435s17.874-17.914,22.807-22.892a3.5,3.5,0,0,0,.069-4.967c-2.185-2.282-7.406-7.406-7.406-7.406a9.015,9.015,0,0,0-.537,1.025,26.022,26.022,0,0,1-1.109,2.572C710.469,256.018,708.366,257.874,704.966,258Z",
        transform: "translate(665.581 300.246)"
      })]
    })
  });
};

exports.SeparatorSymbol = SeparatorSymbol;
var _default = SeparatorSymbol;
exports.default = _default;